import React from "react";
import BannerSection from "../inc/BannerSection";
import Banner from "../images/banner.jpg";

const DeleteAccountInstructions = () => {
  const pageTitle = "Delete Account Instructions";

  return (
    <>
      <BannerSection banner={Banner} name={"Home"} title={pageTitle} />
      <section className="py-5 termscontent">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h3 style={{ textDecoration: "underline", fontSize: "2em" }}>
                Web
              </h3>
              <p style={{ fontSize: 20 }}>
                Delete account instructions for the web.
              </p>

              <h4>Login</h4>
              <p>
                Click on the "User Login" or "Therapist Login" button to
                navigate to the login screen.
              </p>
              <p>
                Log in using the available methods (social login or manual
                login).
              </p>

              <h4>Navigate to Profile Settings</h4>
              <p>
                After logging in, you will be redirected to the dashboard. Click
                on the "Profile Settings" tab located in the left sidebar, or
                simply click on the "Profile" tab in the header.
              </p>

              <h4>Delete Account By User</h4>
              <p>To delete account, press the "Delete" button.</p>
              <p>
                <strong>Note:</strong> If user delete his account, he can
                recover it within seven days. After seven days, the account will
                be permanently deleted, and user will no longer be able to log
                in. If an account is deleted by an admin, it will be permanently
                deleted, and user will not be able to log in.
              </p>
              <h4>Delete Account By Admin</h4>

              <p>
                If admin delete user's account, it will be permanently deleted,
                and user will not be able to log in.
              </p>
            </div>
            <div>
              <h3 style={{ textDecoration: "underline", fontSize: "2em" }}>
                App
              </h3>
              <p style={{ fontSize: 20 }}>
                Delete account instructions for the app.
              </p>

              <h4>Login</h4>
              <p>
                Log in using the available methods (social login or manual
                login).
              </p>

              <h4>Navigate to Account tab</h4>
              <p>
                After logging in, you will be redirected to the Home Tab. Click
                on the "Account" tab located in the bottom navigation.
              </p>

              <h4>Delete Account By User</h4>
              <p>To delete account, press the "Delete" button.</p>
              <p>
                <strong>Note:</strong> If user delete his account, he can
                recover it within seven days. After seven days, the account will
                be permanently deleted, and user will no longer be able to log
                in. If an account is deleted by an admin, it will be permanently
                deleted, and user will not be able to log in.
              </p>
              <h4>Delete Account By Admin</h4>

              <p>
                If admin delete user's account, it will be permanently deleted,
                and user will not be able to log in.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DeleteAccountInstructions;
